export const DEAL_TASK_STATUS_INITIAL: string = 'initial';
export const DEAL_TASK_STATUS_COMPLETED: string = 'completed';
export const DEAL_TASK_STATUS_REJECTED: string = 'rejected';
export const DEAL_TASK_STATUS_APPROVED: string = 'approved';
